import { css, useTheme } from "@emotion/react";
import clsx from "clsx";

import BackgroundColorContextProvider from "./BackgroundColorContextProvider.jsx";
import parseStyle from "./parseStyle.js";
import useThemeProps from "./useThemeProps.jsx";

const PageSectionRoot = ({
  as: Component = "div",
  backgroundColor,
  backgroundColorStart,
  spacingStart,
  spacingEnd,
  children,
  ...restProps
}) => {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  return (
    <Component
      css={css({
        backgroundColor,
        [[
          `.wsui-page-section:not([data-wsui-background-color-end="${backgroundColorStart}"]) + &`,
          `*:not(.wsui-page-section) + &`,
          `&:first-of-type`,
        ]]: {
          paddingBlockStart:
            backgroundColor === "transparent"
              ? null
              : theme.getLength(spacingStart),
        },
        marginBlockStart:
          backgroundColor === "transparent"
            ? theme.getLength(spacingStart)
            : null,
        [backgroundColor === "transparent"
          ? "marginBlockEnd"
          : "paddingBlockEnd"]: theme.getLength(spacingEnd),
      })}
      {...restProps}
    >
      <BackgroundColorContextProvider backgroundColor={backgroundColor}>
        {children}
      </BackgroundColorContextProvider>
    </Component>
  );
};

export default function PageSection(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "PageSection" });
  let {
    background = null,
    backgroundColorStart,
    backgroundColorEnd,
    spacing = [10, 20],
    spacingStart = spacing,
    spacingEnd = spacing,
    className,
    children,
    style,
    ...restProps
  } = props;
  let backgroundColor = (background && theme.getColor(background)) || null;
  backgroundColorStart ??= backgroundColor;
  backgroundColorEnd ??= backgroundColor;
  return (
    <PageSectionRoot
      data-wsui-background-color-start={backgroundColorStart}
      data-wsui-background-color-end={backgroundColorEnd}
      className={clsx(className, "wsui-page-section")}
      backgroundColor={backgroundColor}
      backgroundColorStart={backgroundColorStart}
      spacingStart={spacingStart}
      spacingEnd={spacingEnd}
      css={css`
        color: ${(background && theme.getColor([background, "text"])) || null};
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      {children}
    </PageSectionRoot>
  );
}
